function transformOrderAndTradeChange(data) {
  const {
    Messagetype: messageType,
    InvestorBourseCodeId: investorBourseCodeId,
    InvestorBourseCode: investorBourseCode,
    InvestorTitle: investorTitle,
    PersonageId: personageId,
    OrderId: orderId,
    ErrorCode: errorCode,
    ErrorDescription: errorDescription,
    Description: description,
    EnglishDescription: englishDescription,
    OrderSideId: orderSideId,
    OrderSide: orderSide,
    OrderStateId: orderStateId,
    OrderState: orderState,
    OrderStateEnglishTitle: orderStateEnglishTitle,
    InstrumentIsin: instrumentIdentification,
    InstrumentName: instrumentName,
    InstrumentTitle: instrumentTitle,
    HostOrderNumber: hostOrderNumber,
    InstrumentTypeCode: instrumentTypeCode,
    SectorCode: sectorCode,
    SubSectorCode: subSectorCode,
    ExchangeCode: exchangeCode,
    MarketCode: marketCode,
    InstrumentGroupId: instrumentGroupId,
    InstrumentStateCode: instrumentStateCode,
    Price: price,
    Quantity: quantity,
    ExecutedQuantity: executedQuantity,
    RemainingQuantity: remainingQuantity,
    BlokedValue: blokedValue,
    ValidityTypeId: validityTypeId,
    ValidityTypeTitle: validityTypeTitle,
    ValidityDate: validityDate,
    EntryDate: entryDate,
    ReferencePriceVariationPercentage: referencePriceVariationPercentage,
    ParentOrderStateId: parentOrderStateId,
    ParentOrderState: parentOrderState,
    parentOrderId: parentOrderId,
    DateOfEvent: dateOfEvent,
    TradeQauntity: tradeQuantity,
    TradePrice: tradePrice,
    OrderExecutionType: orderExecutionType,
    IsAlgorithm: isAlgorithm,
  } = data;

  return {
    messageType,
    investorBourseCodeId,
    investorBourseCode,
    investorTitle,
    personageId,
    orderId: String(orderId),
    errorCode,
    errorDescription,
    description,
    englishDescription,
    orderSideId,
    orderSide,
    orderStateId,
    orderState,
    orderStateEnglishTitle,
    instrumentIdentification,
    instrumentName,
    instrumentTitle,
    hostOrderNumber,
    instrumentTypeCode,
    sectorCode,
    subSectorCode,
    exchangeCode,
    marketCode,
    instrumentGroupId,
    instrumentStateCode,
    price,
    quantity,
    executedQuantity,
    remainingQuantity,
    blokedValue,
    validityTypeId,
    validityTypeTitle,
    validityDate,
    entryDate,
    referencePriceVariationPercentage,
    parentOrderStateId,
    parentOrderState,
    parentOrderId: String(parentOrderId),
    dateOfEvent,
    tradeQuantity,
    tradePrice,
    orderExecutionType,
    isAlgorithm,
  };
}

function transformNewOmsOrderAndTradeChange(data) {
  const {
    Messagetype: messageType,
    MessageDetailtype: messageDetail,
    InvestorBourseCodeId: investorBourseCodeId,
    InvestorBourseCode: investorBourseCode,
    InvestorTitle: investorTitle,
    PersonageId: personageId,
    OrderId: orderId,
    ErrorCode: errorCode,
    ErrorDescription: errorDescription,
    Description: description,
    EnglishDescription: englishDescription,
    OrderSideId: orderSideId,
    OrderSide: orderSide,
    OrderStateId: orderStateId,
    OrderStatePersianTitle: orderState,
    OrderStateEnglishTitle: orderStateEnglishTitle,
    InstrumentIsin: instrumentIdentification,
    InstrumentName: instrumentName,
    InstrumentTitle: instrumentTitle,
    HostOrderNumber: hostOrderNumber,
    InstrumentTypeCode: instrumentTypeCode,
    SectorCode: sectorCode,
    SubSectorCode: subSectorCode,
    ExchangeCode: exchangeCode,
    MarketCode: marketCode,
    InstrumentGroupId: instrumentGroupId,
    InstrumentStateCode: instrumentStateCode,
    Price: price,
    Quantity: quantity,
    RemainingQuantity: remainingQuantity,
    BlokedValue: blokedValue,
    ValidityTypeId: validityTypeId,
    ValidityTypeTitle: validityTypeTitle,
    ValidityDate: validityDate,
    EntryDate: entryDate,
    ReferencePriceVariationPercentage: referencePriceVariationPercentage,
    ParentOrderStateId: parentOrderStateId,
    ParentOrderState: parentOrderState,
    parentOrderId: parentOrderId,
    DateOfEvent: dateOfEvent,
    TradeQauntity: tradeQuantity,
    TradePrice: tradePrice,
    OrderExecutionType: orderExecutionType,
    IsAlgorithm: isAlgorithm,
  } = data;

  return {
    messageType,
    messageDetail,
    investorBourseCodeId,
    investorBourseCode,
    investorTitle,
    personageId,
    orderId: String(orderId),
    errorCode,
    errorDescription,
    description,
    englishDescription,
    orderSideId,
    orderSide,
    orderStateId,
    orderState,
    orderStateEnglishTitle,
    instrumentIdentification,
    instrumentName,
    instrumentTitle,
    hostOrderNumber,
    instrumentTypeCode,
    sectorCode,
    subSectorCode,
    exchangeCode,
    marketCode,
    instrumentGroupId,
    instrumentStateCode,
    price,
    quantity,
    executedQuantity: quantity - remainingQuantity,
    remainingQuantity,
    blokedValue,
    validityTypeId,
    validityTypeTitle,
    validityDate,
    entryDate,
    referencePriceVariationPercentage,
    parentOrderStateId,
    parentOrderState,
    parentOrderId,
    dateOfEvent,
    tradeQuantity,
    tradePrice,
    orderExecutionType,
    isAlgorithm,
  };
}

export { transformOrderAndTradeChange, transformNewOmsOrderAndTradeChange };
